var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.position")) +
                " > " +
                _vm._s(_vm.$t("sidebar.create")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("HrmPositionForm", {
            attrs: {
              isSubmitted: _vm.isSubmitted,
              employees: _vm.employees,
              disabled: _vm.disabled,
              form: _vm.form,
              showActionButtons: _vm.hasRoleEdit
            },
            on: {
              "update:form": function($event) {
                _vm.form = $event
              },
              onSubmit: _vm.handleSubmit
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797b1fc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797b1fc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/hrm/position/Create.vue
// module id = null
// module chunks = 